<template>
  <div class="ml-5" justify="center">
    <div class="user-configuration-container">
      <div class="user-configuration-form-title">
        <h1 class="my-5 text-center">{{ $t('api.third_party_services') }}</h1>
      </div>
      <v-row justify="center">
        <v-col :cols="isMobile ? 8 : 3">
          <v-text-field
            dense
            x-small
            outlined
            class="rounded-lg"
            type="text"
            :label="$t('api.token_label')"
            v-model="labelToken"
            :rules="labelRules"
            @keyup.enter="addToken">
          </v-text-field>
          <p style="color: red">{{ message }}</p>
        </v-col>
        <v-col :cols="isMobile ? 8 : 3">
          <template>
            <v-btn
              style="margin-top: 6px"
              color="primary"
              small
              @click="addToken"
              :disabled="labelToken && labelToken.length >= 3 ? false : true">
              <v-icon>mdi-creation</v-icon>
              {{ $t('general.form.generate') }}
            </v-btn>
            <v-snackbar v-model="snackbar" :timeout="timeout" color="success">
              <div class="d-flex mx-auto" style="width: 40px">{{ $t('api.snack_text') }}</div>
            </v-snackbar>
          </template>
        </v-col>
      </v-row>
      <v-row v-for="(element, index) in data" :key="element.token" justify="center">
        <v-col cols="3">
          <p>{{ element.name }}</p>
        </v-col>
        <v-col cols="4" class="codeBox">
          <p>{{ element.token }}</p>
        </v-col>
        <v-col class="mt-2" cols="4">
          <v-row justify="center">
            <v-btn class="iconCopy" x-small text @click="copyToClipboard(index)">
              <v-icon small color="success">{{ iconCollection[index] || 'mdi-content-copy' }}</v-icon>
            </v-btn>
          </v-row>
          <v-btn class="iconTrash" small text @click="deleteToken(element.name)"><v-icon color="error">mdi-delete</v-icon></v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
const userviewmodel = require('../../../viewModels/userViewModel');
const ls = require('localstorage-slim');
const VueI18n = require('../../../plugins/lang/index');

export default {
  data: () => ({
    labelRules: [
      (value) => !!value || VueI18n.default.t('api.labelRules.required'),
      (value) => (value && value.length >= 3) || VueI18n.default.t('api.labelRules.minLength'),
    ],
    data: [],
    randomCode: '',
    theme: ls.get('theme') ?? 'light',
    labelToken: '',
    token: '',
    message: '',
    iconCollection: [],
    iconCopy: 'mdi-content-copy',
    iconCheck: 'mdi-check-bold',
    snackbar: false,
    timeout: 2000,
  }),
  mounted: async function () {
    this.data = await userviewmodel.fetchThirdPartyToken();
  },
  methods: {
    codeGenerator() {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let codeString = '';
      this.randomCode = '';
      for (let i = 0; i < 15; i++) {
        codeString += characters.charAt(Math.floor(Math.random() * characters.length));
      }
      this.randomCode = codeString;
      return codeString;
    },

    copyToClipboard(index) {
      this.snackbar = true;
      navigator.clipboard.writeText(this.data[index].token);
      this.$set(this.iconCollection, index, this.iconCheck);
      setTimeout(() => {
        this.$set(this.iconCollection, index, this.iconCopy);
      }, 2000);
    },

    async addToken() {
      if (this.data.length < 5 && this.labelToken) {
        this.token = this.codeGenerator();

        const payload = {
          name: this.labelToken,
          token: this.token,
        };

        if (!this.validationName()) {
          this.data.push(payload);
          await userviewmodel.thirdPartyToken(payload);
          this.labelToken = '';
        } else {
          this.message = this.$t('api.no_repetead_name');
        }
      } else {
        this.message = this.$t('api.message');
        setTimeout(() => {
          this.message = '';
        }, 3000);
      }
    },

    async deleteToken(tokenName) {
      this.data.splice(tokenName, 1);
      await userviewmodel.delThirdPartyToken(tokenName);
    },

    validationName() {
      return this.data.some((item) => item.name === this.labelToken);
    },
  },
  computed: {
    isDarkMode() {
      this.theme = ls.get('theme');

      return this.theme;
    },
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
  },
};
</script>
<style scoped>
.codeBox {
  display: flex;
  flex-direction: column;
  width: 80px;
  height: 45px;
  background-color: rgba(0, 0, 0, 0.058);
  border-radius: 10px;
}

.iconCopy {
  display: block;
  position: relative;
  top: -4%;
  left: -58%;
}

.iconTrash {
  display: block;
  position: relative;
  bottom: 20%;
  left: -2%;
}
</style>
